/* eslint-disable react/no-unstable-nested-components */
import { useMemo, useState } from 'react'
import { Col, Form, Row, Select } from 'antd'

import EAReport from 'Components/UI/EAReport'
import EAReportExport from 'Components/UI/EAReport/Export'
import EAReportTable from 'Components/UI/EAReport/Table'
import EARequestErrorResult from 'Components/UI/EARequestErrorResult'

import useReportData from 'Components/UI/EAReport/hooks/useReportData'
import useEstabelecimentos from 'Hooks/estabelecimento/useEstabelecimentos'
import useUsuarios from 'Hooks/usuario/useUsuarios'

import columns from './columns'

const { Option } = Select

const RelatorioVendaAtendenteDetalhePage = () => {
  const { estabelecimentosRequest } = useEstabelecimentos()
  const { usuariosRequest } = useUsuarios()

  const { fetchReportData, reportDataRequest } = useReportData({
    columns,
    url: '/relatorio/vendas_por_atendente_detalhe/'
  })

  const [filtros, setFiltros] = useState(null)

  if (estabelecimentosRequest.hasError || usuariosRequest.hasError) {
    return <EARequestErrorResult />
  }

  const filtrosDetalhados = useMemo(() => {
    if (!filtros) return null

    const estab = estabelecimentosRequest.data?.find(
      (e) => e.idestabelecimento === filtros.estabelecimento
    )?.descricao

    const atend = usuariosRequest.data?.find(
      (u) => u.idusuario === filtros.atendente
    )?.login

    return {
      Estabelecimento: estab,
      Atendente: atend
    }
  }, [filtros])

  return (
    <EAReport
      title="Relatório de vendas por atendente - Detalhe"
      dataRenderer={
        <EAReportTable
          columns={columns}
          dataSource={reportDataRequest.data || []}
        />
      }
      exportRenderer={
        <EAReportExport
          columns={columns}
          dataSource={reportDataRequest.data}
          filtrosDetalhados={filtrosDetalhados}
          reportName="vendas_por_atendente_detalhe"
        />
      }
      filterRenderer={() => (
        <Row gutter={16}>
          <Col xs={24} md={12}>
            <Form.Item
              name="estabelecimento"
              label="Estabelecimento"
              rules={[{ required: true, message: 'Obrigatório.' }]}
            >
              <Select style={{ width: '100%' }}>
                {estabelecimentosRequest.data?.map((e) => (
                  <Option key={e.idestabelecimento} value={e.idestabelecimento}>
                    {e.descricao}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              name="atendente"
              label="Atendente"
              rules={[{ required: true, message: 'Obrigatório.' }]}
            >
              <Select style={{ width: '100%' }}>
                {usuariosRequest.data?.map((u) => (
                  <Option key={u.idusuario} value={u.idusuario}>
                    {u.login}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      )}
      loading={
        estabelecimentosRequest.isLoading ||
        usuariosRequest.isLoading ||
        reportDataRequest.isLoading
      }
      onSubmit={(dados) => {
        const payload = { ...dados }
        setFiltros(payload)
        fetchReportData(payload)
      }}
    />
  )
}

export default RelatorioVendaAtendenteDetalhePage
